const ILANLAR = [
    {
      "title": "Satılık Ev",
      "desciption": "Ankara'da satılık ev ilanı için dernek hattı üzerinden iletişime geçebilirsiniz. İlan detayları güncellendikçe bu sayfada paylaşılacaktır.",
      "phone": "0553 071 96 04",
      "category": "Satılık, Ev, Daire"
    },
 
  ]
  export default ILANLAR
